import { useFormat } from '@ideavivat/vivat-2';
import useDelivery from '@/useDelivery';

const { shipmentStatusClassMap, translate, typeTranslate } = useDelivery();

export default {
  types: {
    // _primaryControls: {
    //   width: '3rem',
    // },
    _selectorControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    // code: {
    //   name: 'เลขที่ใบวางบิล',
    //   width: '8rem',
    //   class: {
    //     text: 'text-center',
    //     cell: 'text-center',
    //   },
    // },
    // createdAt: {
    //   name: 'วันที่สร้างบิล',
    //   width: '10rem',
    //   // eslint-disable-next-line
    //   filter: (val: string, row: any) => row.item?.invoice?.createdAt ? useFormat.date(row.item.invoice.createdAt).displayShortThaiDateTime() : '',
    //   class: 'text-center',
    // },

    deliveryNote: {
      name: 'เลขที่รายการจัดส่ง (DN)',
      width: '11rem',
      class: 'text-left ml-3',
      // eslint-disable-next-line
      filter: (val: any, row: any) =>  val?.uniqueId ? val.uniqueId : '',
    },
    orderNumber: {
      name: 'เลขที่ใบส่งสินค้า (DO)',
      width: '11rem',
      class: 'text-left',
    },
    type: {
      name: 'ประเภท',
      width: '6rem',
      filter: (val: string) => typeTranslate(val),
    },
    totalWeight: {
      name: 'น้ำหนัก (กก.)',
      width: '8rem',
      filter(val: string) {
        return parseFloat(val).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      class: 'text-right',
    },
    deliveryFee: {
      name: 'ค่าจัดส่ง',
      width: '9rem',
      class: 'text-right mr-3',
      // filter: (val: string, row: any) => useFormat.number(val).currency(),
      // eslint-disable-next-line
      filter: (val: string, row: any) => {
        return useFormat.number(parseInt(val, 10) - row.item.deliveryDiscount).currency();
      },
    },
    status: {
      name: 'สถานะ',
      width: '12rem',
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return shipmentStatusClassMap(val);
        },
      },
      filter(val: string, row: { item: { [key: string]: any }; index: number }) {
        return translate(val);
      },
    },
    completedDate: {
      name: 'วันที่ส่งสำเร็จ',
      width: '7rem',
      // eslint-disable-next-line
      filter: (val: string, row: any) => row.item?.completedDate ? useFormat.date(row.item.completedDate).displayShortThaiDate() : '',
      class: 'text-center',
    },
    senderCode: {
      name: 'รหัสผู้ฝากส่ง',
      width: '6rem',
      class: {
        text: 'text-left',
        cell: 'text-left',
      },
    },
    senderName: {
      name: 'ชื่อผู้ฝากส่ง',
      width: '16rem',
      // eslint-disable-next-line
      filter: (val: string) => val !== 'NA' ? val : '',
      class: {
        text: 'text-center mx-3',
        cell: 'text-center mx-3',
      },
    },
    customerCode: {
      name: 'รหัสผู้รับ',
      width: '10rem',
      class: {
        text: 'text-left mr-3',
        cell: 'text-left mr-6',
      },
    },
    customerName: {
      name: 'ชื่อผู้รับ',
      width: '16rem',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
    },
    path: {
      name: 'เส้นทางจัดส่ง',
      width: '6rem',
    },
    // createdBy: {
    //   name: 'ผู้สร้างรายการ',
    //   width: '10rem',
    //   class: {
    //     text: 'text-left',
    //     cell: 'text-center',
    //   },
    //   // eslint-disable-next-line
    //   filter: (val: any, row: any) =>  row.item.invoice && row.item.invoice.createdBy ? row.item.invoice.createdBy?.name : '',
    // },
  },
  sortable: [
    'createdAt',
    // 'deliveryNote.uniqueId',
    'completedDate',
    'orderNumber',
    'status',
    'customerName',
    'totalWeight',
    'deliveryFee',
    'createdBy',
  ],
};
